/**
 * R3-3 (rc4): a number box that takes digits only.
 *
 * A browser's own `type="number"` box lets "e", "+", "-" and "." be typed (they can form a number in its rules: 1e3, -2, 2.5),
 * and a phone's keyboard can offer letters. Round 3's tester typed into an Age question: every letter was refused but "e". Anudan's
 * number questions and counts are whole numbers of zero or more (the server refuses anything else), so the box says so as the
 * donor types: no "e", "+", "-" or ".", the numeric keyboard on phones, and a paste keeps only its digits. 0.9.41: no box takes a
 * minus any more; a fund's question can no longer have a minimum below zero.
 */

/**
 * Makes a number box take digits only.
 *
 * @param {HTMLInputElement} input
 * @return {HTMLInputElement}
 */
export function digitsOnly( input ) {
	const refused = /[^0-9]/;

	input.inputMode = 'numeric';
	input.setAttribute( 'pattern', '[0-9]*' );

	input.addEventListener( 'keydown', ( event ) => {
		if ( event.ctrlKey || event.metaKey || event.altKey || 1 !== String( event.key || '' ).length ) {
			return;
		}

		if ( refused.test( event.key ) ) {
			event.preventDefault();
		}
	} );

	// A phone's keyboard often reports no key; what it is about to insert is checked instead.
	input.addEventListener( 'beforeinput', ( event ) => {
		if ( 'insertText' === event.inputType && event.data && refused.test( event.data ) ) {
			event.preventDefault();
		}
	} );

	input.addEventListener( 'paste', ( event ) => {
		const text = event.clipboardData ? event.clipboardData.getData( 'text' ) : '';
		const digits = text.replace( /[^0-9]/g, '' );

		event.preventDefault();

		if ( '' === digits ) {
			return;
		}

		input.value = digits;
		input.dispatchEvent( new Event( 'input', { bubbles: true } ) );
		input.dispatchEvent( new Event( 'change', { bubbles: true } ) );
	} );

	input.addEventListener( 'drop', ( event ) => event.preventDefault() );

	return input;
}
